<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-ranking`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 4a1 1 0 00-1-1H8a1 1 0 00-1 1v38.232a2 2 0 002.628 1.9L24 39.38l14.372 4.751A1.999 1.999 0 0041 42.232V4zm-30.5 9h27v27.157L24 35.693l-13.5 4.464V13zm13.943 3.363a1 1 0 01.454.454l2.042 4.138 4.566.664a1 1 0 01.555 1.705l-3.305 3.221.78 4.548a1 1 0 01-1.45 1.054L24 30l-4.084 2.147a1 1 0 01-1.451-1.054l.78-4.548-3.305-3.22a1 1 0 01.555-1.706l4.566-.664 2.042-4.138a1 1 0 011.34-.454zM10.5 6.5h27V9h-27V6.5z"/></svg>
</template>
<script>

export default {
  name: 'IconRanking',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
